import type { TypographyProps } from "../../atoms/typography";
import type { NavHeaderVariant } from "./types";

type TypographyColor = NonNullable<TypographyProps["color"]>;

/** Title color per variant. */
export const navHeaderTitleColor: Record<NavHeaderVariant, TypographyColor> = {
  brand: "brand-on-static",
  white: "neutral-foreground-default",
  transparent: "brand-on-static",
};

/**
 * Subtitle color per variant: smalt-100 on the brand bar (Ardhi Q5,
 * 2026-10-30), and on the transparent bar too, which Figma doesn't draw
 * (coordinator, 2026-11-03); `foreground-default` on the white bar, as Figma
 * draws it (Ardhi's DQ7 (c) answer, 2026-11-03).
 */
export const navHeaderSubtitleColor: Record<NavHeaderVariant, TypographyColor> = {
  brand: "brand-on-static-attenuated",
  white: "neutral-foreground-default",
  transparent: "brand-on-static-attenuated",
};

/** Icon tint class for the back button per variant. */
export const navHeaderIconColor: Record<NavHeaderVariant, string> = {
  brand: "text-luce-brand-onStatic",
  white: "text-luce-neutral-foreground-default",
  transparent: "text-luce-brand-onStatic",
};
